/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useSelector } from 'react-redux';

import { getTranslation } from '../../utils/utils';
import { useTranslation } from "react-i18next";
import { deleteSurveyAnswersT2, updateSurveyAnswersT2, updateSurveyAnswers, removeSurveyAnswer } from '../../redux/action/surveyAction';
import { useOktaAuth } from '@okta/okta-react';

import { Card, Col, Button } from '@deere/ux.uxframe-react';
import { Form } from 'react-bootstrap';
import { ReactComponent as AddIcon } from "@deere/ux.brand-foundations/icons/add.svg";

import { getBoundary } from '../../services/external.service';
import { EMPTY_BODY, SCBM_INDIRECT, TIER_LABOR_NAME_INDIRECT } from '../../utils/surveyLiterals';
import { TierModal } from '../../components/TierModal';
import { findAnswerIndex, getGroupTierArray, containsCheckBoxAnswer, getNewCheckValueAnswer, removeQuestion } from '../../utils/utils';
import RadioGroup from '../../components/RadioGroup';

import { updateAnswerInArray } from '../../utils/utils';

import store from '../../redux/store';
import CheckGroup from '../../components/CheckGroup';
import { DebounceInput } from 'react-debounce-input';

export const TierPage = ({ survey, country, updatedByName, supplierName }) => {

    const section = survey ? survey.sections.find(e => e.description === TIER_LABOR_NAME_INDIRECT) : [];

    const surveyAnswers = useSelector(state => state.survey.surveyAnswers);
    const tierForms = surveyAnswers.filter(answer => answer.tierIndex > 0);
    const questions = section && section.questions ? section.questions.sort((a, b) => (a.showOrder > b.showOrder) ? 1 : -1) : [];
    const [tierContacts, setTierContacts] = useState(getGroupTierArray(tierForms, questions, true, SCBM_INDIRECT));

    const [answers, setAnswers] = useState([]);
    const [checkSection] = useState(false);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const [tier2Array, setTier2Array] = useState([]);
    const [contact, setContact] = useState([]);
    const { authState } = useOktaAuth();
    const [boundary, setBoundary] = useState([[]]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const [selectedCountry, setSelectedCountry] = useState({
        idx: 0,
        cc: '',
        name: '',
        loading: false
    });

    useEffect(() => {
        setAnswers([...store.getState().survey.surveyAnswers]);
    }, [surveyAnswers])

    if (surveyAnswers.length > 0 && !dataLoaded) {
        setDataLoaded(true);
    }
    useEffect(() => {
        setTierContacts(getGroupTierArray(tierForms, questions, true, SCBM_INDIRECT));
    }, [setDataLoaded]);

    useEffect(() => {
        setTier2Array([...tierContacts])
        iterateContact()
    }, [tierContacts]);

    function iterateContact() {
        for (let index = 0; index < tier2Array.length; index++) {
            setFlags(index, tier2Array)
        }
    }

    const [initialLoading, setInitialLoading] = useState(false);
    useEffect(() => {
        const getBoundaries = async () => {
            tier2Array.forEach(items => {
                items.forEach(item => {
                    country.forEach(async (coun) => {
                        if (item.answer.toLowerCase() === coun.name.toLowerCase()) {
                            let countryRegions;
                            try {
                                setInitialLoading(true);
                                countryRegions = await getBoundary(authState.accessToken.accessToken, coun.iso2CountryCode);                                
                            } catch (err) {
                                setInitialLoading(false);
                                console.log(err);
                                countryRegions = [[]];
                            }
                            if (countryRegions.length > 0) {
                                boundary[item.tierIndex - 1] = [...countryRegions];                                
                            } else {
                                boundary[item.tierIndex - 1] = [{
                                    name: coun.name,
                                    abbreviated: coun.name,
                                    type: 'State'
                                }];
                            }
                            setInitialLoading(false);
                        }
                    });
                });
            });
        };
        getBoundaries();
    }, [country])

    useEffect(() => {
        async function getBdry() {
            let countryRegions;

            const index = selectedCountry.idx;
            const countrycode = selectedCountry.cc;

            if (countrycode !== '') {
                try {
                    countryRegions = await getBoundary(authState.accessToken.accessToken, countrycode);
                } catch (err) {
                    console.log(err);
                }
                if (countryRegions.length > 0) {
                    boundary[index] = { ...countryRegions };
                } else {
                    boundary[index] = [{
                        name: '-',
                        abbreviated: '',
                        type: 'No State'
                    }];
                    dispatch(updateSurveyAnswersT2({ questionId: questions[4].id , answer: '', tierIndex: index + 1 }));
                }
                setSelectedCountry({
                    ...selectedCountry,
                    loading: false
                });
            }
        }
        selectedCountry.name !== '' &&
            getBdry();
    }, [selectedCountry.loading]);

    if (!survey) {
        return EMPTY_BODY
    }

    const isOtherChecked = (question, answers) => {
        let isChecked = false;
        let isCheckedParent = true;
        let parentAns = answers.find(qu => parseInt(qu.questionId) === parseInt(question.idQuestionDepends));
        let parentQu = questions.find( qu => parseInt(qu.id) === parseInt(question.idQuestionDepends));
        if(parentQu && parentQu.idQuestionDepends && parentQu.idQuestionDepends !== 0) {
            let granParentAns = answers.find(qu => parseInt(qu.questionId) === parseInt(parentQu.idQuestionDepends));
            if(granParentAns) {
                isCheckedParent = parseInt(parentQu.idSelectionDependson) === parseInt(granParentAns.answer);
            }
        }

        if(parentAns && containsCheckBoxAnswer(question.idSelectionDependson.toString(),parentAns.answer)){
            isChecked = true;
        }
        return isChecked && isCheckedParent;
    }

    const handleCheckChange = (e, idQuestion) => {
        updateCheckAnswer(e, idQuestion);
    }

    const updateCheckAnswer = (e, questionId) => {
        let newCheckValue = getNewCheckValueAnswer(questionId, answers, e);
        if (newCheckValue === null || newCheckValue === '' || newCheckValue === ',') {//Remove Question
            removeQuestion(questionId, answers);
            dispatch(removeSurveyAnswer(questionId));
        } else {//Update Question
            updateAnswerInArray(questionId, answers, newCheckValue);
            dispatch(updateSurveyAnswers({ questionId: questionId, answer: newCheckValue }));
        }
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    const updateAnswer = (e, questionId) => {
        updateAnswerInArray(questionId, answers, e.target ? e.target.value : e);
        dispatch(updateSurveyAnswers({ questionId: questionId, answer: e.target ? e.target.value : e }));
        setAnswers([...store.getState().survey.surveyAnswers])
    }

    function setFlags(index, answersContact) {
        const flags = [...contact]
        flags[index] = false
        for (let i = 0; i < answersContact.length; i++) {
            flags[index] = flags[index] || answersContact[i].answer
        }
        setContact([...flags])
    }

    function containsCountry(event, index) {
        const countryValue = event.target.value;
        if (!countryValue || countryValue === undefined)
            return setSelectedCountry({
                idx: 0,
                cc: '',
                name: '',
                loading: false
            })
        for (let i = 0; i < country.length; i++) {
            if (country[i].name.toLowerCase() === countryValue.toLowerCase()) {
                const indexx = event.target.selectedIndex;
                const optionElement = event.target.childNodes[indexx];
                let countryCode = '';
                if (optionElement !== undefined) {
                    countryCode = optionElement.getAttribute('id');
                }
                if (countryCode.toLowerCase() !== country[i].name.toLowerCase()) {
                    setSelectedCountry({
                        idx: index,
                        cc: countryCode,
                        name: countryValue,
                        loading: true
                    })
                    break;
                }
            }
        }
    }

    const onChange = (questionId, event, index) => {
        let temp = [...tier2Array];
        let answersContact = temp[index]
        let idx = answersContact.find(ans => parseInt(ans.questionId) === parseInt(questionId))
        if (idx) {
            idx.answer = event.target.value
            dispatch(updateSurveyAnswersT2({ questionId: questionId, answer: event.target.value, tierIndex: index + 1 }));
            setTier2Array([...temp])
            setFlags(index, answersContact)
        }
    }

    const onBlur = (event,index)=>{
        containsCountry(event, index);
    }

    const addSupplier = (e) => {
        const tierLastIndex = tier2Array.length
        if (tierLastIndex < 10) {
            const temp = [...tier2Array]
            const array = []
            for (let i = 0; i < 7; i++) {
                array.push({
                    tierIndex: tierLastIndex,
                    answer: '',
                    questionId: questions[i].id
                })
            }

            setBoundary([...boundary, []]);

            temp.push(array)
            setTier2Array([...temp]);
        }
    }

    const removeSupplier = (index, e) => {
        const temp = [...tier2Array]
        const filtered = temp.filter((x, idx) => idx !== index)
        for (let i = 0; i < filtered.length; i++) {
            for (let j = 0; j < filtered[i].length; j++) {
                filtered[i][j].tierIndex = i + 1
            }
        }

        const filtredData = [];
        for (let idx = 0; boundary.length > idx; idx++) {
            idx !== index &&
                filtredData.push(boundary[idx]);
        }
        setBoundary([...filtredData]);

        setTier2Array([...filtered])
        dispatch(deleteSurveyAnswersT2({ tierIndex: index + 1 }));
    }

    function FormBody(tier, index) {
        tier = tier.sort((a, b) => (a.questionId > b.questionId) ? 1 : -1);
        return (<div key={index} className="border-top pt-3">
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">{getTranslation(questions[0], 'text')}</Form.Label>
                    <Form.Control required={contact[index]} onChange={e => onChange(questions[0].id, e, index)}
                        value={tier.filter(item => item.questionId === questions[0].id)[0]
                            ? tier.filter(item => item.questionId === questions[0].id)[0].answer
                            : ''}
                        placeholder={t('t2_supplier_name')}
                        name={`${getTranslation(section, 'description')}-`+index}
                    />
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">{getTranslation(questions[1], 'text')}</Form.Label>
                    <Form.Control
                        id={index}
                        as="select"
                        className="custom-select"
                        size="sm"
                        required={contact[index]}
                        value={tier.filter(item => item.questionId === questions[1].id)[0]
                            ? tier.filter(item => item.questionId === questions[1].id)[0].answer
                            : ''}
                        onChange={e => onChange(questions[1].id, e, index)}
                        onBlur={e => onBlur(e, index)}
                        name={`${getTranslation(section, 'description')}-`+index}
                    >
                        <option value="">{t('lbl_dropdown_select')}</option>
                        {
                            country ? country.map(country => <option id={country.iso2CountryCode} key={country.iso2CountryCode}>{country.name}</option>) : null
                        }
                    </Form.Control>
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">{getTranslation(questions[2], 'text')}</Form.Label>
                    <Form.Control required={contact[index]} onChange={e => onChange(questions[2].id, e, index)}
                        name={`${getTranslation(section, 'description')}-`+index}
                        value={tier.filter(item => item.questionId === questions[2].id)[0]
                            ? tier.filter(item => item.questionId === questions[2].id)[0].answer
                            : ''}
                        placeholder={t('t2_critical')}
                    />
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">{getTranslation(questions[3], 'text')}</Form.Label>
                    <Form.Control required={contact[index]} onChange={e => onChange(questions[3].id, e, index)}
                        name={`${getTranslation(section, 'description')}-`+index}
                        value={tier.filter(item => item.questionId === questions[3].id)[0]
                            ? tier.filter(item => item.questionId === questions[3].id)[0].answer
                            : ''}
                        placeholder={t('t2_street')}
                    />
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">{getTranslation(questions[4], 'text')}</Form.Label>
                    <Form.Control
                        required={contact[index]}
                        onChange={e => onChange(questions[4].id, e, index)}
                        value={tier.filter(item => item.questionId === questions[4].id)[0]
                            ? tier.filter(item => item.questionId === questions[4].id)[0].answer
                            : ''}
                        placeholder={t('t2_city')}
                        name={`${getTranslation(section, 'description')}-`+index}
                    />
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">{getTranslation(questions[5], 'text')}</Form.Label>
                    {
                        (selectedCountry.idx === index && selectedCountry.loading) || initialLoading ?
                            <div>
                                <Form.Control 
                                    as="select"
                                    className="custom-select"
                                    size="sm"
                                    value="Loading..."
                                    disabled={true}
                                    data-testid="countryBox"
                                >
                                    <option value="">Loading...</option>
                                </Form.Control>
                            </div>
                            :
                            (boundary[index] !== null && boundary[index] !== undefined) &&
                                (boundary[index][0] && boundary[index][0].type === 'No State') ?
                                <div>
                                    <Form.Control 
                                        value=""
                                        required={true}
                                        id={index}
                                        as="select"
                                        className="custom-select"
                                        size="sm"
                                        disabled={true}
                                        data-testid="countryBox"
                                    >
                                        <option value="">{''}</option>
                                    </Form.Control>
                                    <div className="invalid-feedback">
                                        {t('bs_required')}
                                    </div>
                                </div>
                            :
                            <div>
                                <Form.Control 
                                    required={contact[index]} 
                                    id={index}
                                    as="select"
                                    data-testid="countryBox"
                                    className="custom-select"
                                    size="sm"
                                    value={tier.filter(item => item.questionId === questions[5].id)[0]
                                        ? tier.filter(item => item.questionId === questions[5].id)[0].answer
                                        : ''}
                                    onChange={e => onChange(questions[5].id, e, index)}
                                    name={`${getTranslation(section, 'description')}-`+index}
                                >
                                    <option value="">{t('t2_state_region')}</option>
                                    {
                                        (boundary[index] !== null && boundary[index] !== undefined) &&
                                            (Object.values(boundary[index]).length > 1 || Object.values(boundary[index])[0])
                                            ?
                                            Object.values(boundary[index]).map(bon => {
                                                return <option id={bon.abbreviated} key={bon.name + index}>{bon.name}</option>
                                            })
                                            : null
                                    }
                                </Form.Control>
                                <div className="invalid-feedback">
                                    {t('bs_required')}
                                </div>
                            </div>
                    }
                </Form.Group>
                <Form.Group as={Col}>
                    <Form.Label className="uxf-label">{getTranslation(questions[6], 'text')}</Form.Label>
                    <Form.Control
                        required={contact[index]}
                        onChange={e => onChange(questions[6].id, e, index)}
                        placeholder={t('t2_zip')}
                        value={tier.filter(item => item.questionId === questions[6].id)[0]
                            ? tier.filter(item => item.questionId === questions[6].id)[0].answer
                            : ''}
                        name={`${getTranslation(section, 'description')}-`+index}                  
                    />
                    <div className="invalid-feedback">
                        {t('bs_required')}
                    </div>
                </Form.Group>
            </Form.Row>
            <Form.Row>
                <Form.Group as={Col} className="align-right">
                    <Button onClick={e => removeSupplier(index, e)} variant="uxf-filter" className="float-right" >
                    {t('t2_remove')}
                    </Button>
                </Form.Group>
            </Form.Row>
            {
                index === (tier2Array.length - 1) && tier2Array.length < 10 ? <Form.Row>
                    <Form.Group as={Col} className="align-right">
                        <Button onClick={e => addSupplier(e)} variant="secondary" className="float-right btn-sm" >
                            <AddIcon /> {t('t2_add')}
                        </Button>
                    </Form.Group>
                </Form.Row> : null
            }
        </div>)
    }

    const createOption = ( question ) => {
        return <Form.Row className="d-block mb-4">
            <Form.Group>
                <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                <RadioGroup radioLabels={question ? question.selections : []}
                    updateAnswer={updateAnswer} question={question}
                    defaultValue={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                    section={getTranslation(section, 'description')}
                    checkedProprietary={checkSection}/>
            </Form.Group>
        </Form.Row>
    };

    const createCheck = ( question ) => {
        return <Form.Row className="d-block mb-4">
            {
                isOtherChecked(question,answers) &&
                <Form.Group className="mb-4 pl-4">
                    <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
                    <div><CheckGroup key={2} checkSelections={question ? question.selections : []}
                        handleChange={handleCheckChange} question={question}
                        currentChecked={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''} 
                        section={getTranslation(section, 'description')}
                        checkedproprietary={checkSection}/></div>
                </Form.Group>
            }
        </Form.Row>
    };

    const createTextArea = ( question ) => {
        return <Form.Row className="d-block mb-4">
        {isOtherChecked(question,answers) && <Form.Group className="mb-4 pl-4">
               <Form.Label className="uxf-label">{getTranslation(question, 'text')}</Form.Label>
               <DebounceInput element="textarea" debounceTimeout={300}
                   required={!checkSection} className="form-control"                            
                   onChange={e => updateAnswer(e, question.id)}                             
                   value={findAnswerIndex(question.id, answers) >= 0 ? answers[findAnswerIndex(question.id, answers)].answer : ''}
                   name={`${getTranslation(section, 'description')}-${question.id}`}/>    
               <div className="invalid-feedback">
                   {t('bs_required')}
               </div>
           </Form.Group>}
       </Form.Row>
    }

    return (
        <>
            <Card>
                <Card.Body id={section ? section.description : ''}>
                    <Card.Title className='pb-3 font-weight-bold'>
                        {getTranslation(section, 'description')} 
                    </Card.Title>
                    {createOption( questions[10] )}
                    {createCheck( questions[11] )}
                    {createTextArea( questions[12] )}
                    <small style={{ color: 'gray' }}> {t('t2_subtitle_ind')} </small> <br/><br/>
                    <h6 style={{ color: 'gray' }}>{t('t2_subtitle2')}</h6>
                    {
                        tier2Array.length > 0
                            ? tier2Array.map((tier, index) => FormBody(tier, index))
                            : <div>
                                <Form.Row>
                                    <Form.Group as={Col} className="align-right">
                                        <Button onClick={e => addSupplier(e)} variant="secondary" className="float-right btn-sm" >
                                            <AddIcon /> Add Another
                                        </Button>
                                    </Form.Group>
                                </Form.Row>
                            </div>
                    }
                </Card.Body>
            </Card>
            <TierModal survey={survey} question={questions[7]} supplierName={supplierName} updatedByName={updatedByName} />
        </>)
}
